import type { MessageGroupComponentProps } from '@bitte-ai/types';
import { cn } from '../../../lib/utils';

const DefaultMessageContainer = ({
  isUser,
  children,
  style,
  showBorder,
}: MessageGroupComponentProps) => {
  if (isUser) {
    return (
      <div
        className="bitte-w-full bitte-rounded-md bitte-flex bitte-justify-end bitte-animate-in bitte-fade-in-0 bitte-duration-300"
        data-message-group
      >
        <div
          className={cn(
            'bitte-flex-shrink-0 bitte-max-w-full bitte-bg-gray-900 bitte-p-4 bitte-text-[14px] bitte-rounded-[6px] bitte-break-words',
            showBorder ? 'bitte-border' : '',
          )}
          style={{
            backgroundColor: style.backgroundColor,
            borderColor: style.borderColor,
          }}
        >
          {children}
        </div>
      </div>
    );
  }

  // Agent message - plain text without styling or header
  return (
    <div className="bitte-w-full" data-message-group>
      {children}
    </div>
  );
};

export default DefaultMessageContainer;
